import { Collapse } from "@material-ui/core";
import Add from "@material-ui/icons/Add";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import * as FileSaver from "file-saver";
import { useEffect, useRef, useState } from "react";
import * as XLSX from "xlsx";
import Button from "../../components/UI/Button/Button";
import Modal from "../../components/UI/Modal/Modal";
import LocalSearch from "../../components/UI/Search/Search";
import SelectKiosk from "../../components/UI/Select/Select";
import Table from "../../components/UI/Table/Table";
import UnitKioskForm from "../../components/UnitKiosk/UnitKioskForm";
import fetchData from "../../shared/fetchData";
import CopyUnitKioskForm from "../../components/UnitKiosk/CopyUnitKioskForm";

const UnitKiosks = () => {
  const [loading, setLoading] = useState(false);
  const [rerender, setRerender] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [permission, setPermission] = useState(
    window.localStorage.getItem("permission")
  );
  const [unitKiosks, setUnitKiosks] = useState([]);
  const [kiosks, setKiosks] = useState([]);
  const [kiosk, setKiosk] = useState("");
  const [units, setUnits] = useState([]);
  const [unit, setUnit] = useState("");
  const [unitKiosk, setUnitKiosk] = useState("");
  const [edit, setEdit] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [showUnitKioskForm, setShowUnitKioskForm] = useState(false);
  const ref = useRef();
  useEffect(() => {
    setPageIndex(0);
    setPageSize(10);
    setPageCount(0);
    var raw = JSON.stringify({
      pl: "10000",
      pn: "1",
      version: "mtpx001",
    });
    var url = "management/api/v1/units/getUnits";
    fetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        setUnits(result.units);
      })
      .catch((error) => setLoading(false));
    var url = "management/api/v1/kiosks/getKiosks";
    fetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        setKiosks(result.kiosks);
      })
      .catch((error) => setLoading(false));
  }, []);

  const changeUnit = (selectedOption) => {
    setUnit(selectedOption);
  };

  const changeKiosk = (selectedOption) => {
    setKiosk(selectedOption);
  };
  const UnitKioskChangeStateSubmited = (id) => {
    var raw = JSON.stringify({
      unitKiosk: {
        id: id,
      },
      pl: 1000,
      pn: 1,
      version: "mtpx001",
    });
    var url = "management/api/v1/unitkiosks/changeUnitKioskState";
    fetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == 0) {
          ref.current.closeModal();
          search();
        }
      })
      .catch((error) => console.log());
  };

  const unitKioskChangeState = (id) => {
    setModalContent(
      <div>
        <div className="row justify-content-center">
          آيا از تغيير وضعيت مطمئن هستيد؟
        </div>
        <div className="row justify-content-center mt-5">
          <div className="col-6">
            <Button
              btnType="Success"
              clicked={() => UnitKioskChangeStateSubmited(id)}
            >
              بله
            </Button>
          </div>
          <div className="col-6">
            <Button btnType="General" clicked={() => ref.current.closeModal()}>
              خير
            </Button>
          </div>
        </div>
      </div>
    );
    ref.current.openModal();
  };
  const getData = (pagination, isRefresh) => {
    setPageIndex(pagination.pageIndex);
    setPageSize(pagination.pageSize);
    setLoading(true);
    var raw =
      !!isRefresh && isRefresh
        ? JSON.stringify({
            pl: pagination.pageSize,
            pn: pagination.pageIndex + 1,
            version: "mtpx001",
          })
        : JSON.stringify({
            unitKiosk: {
              unitId: !!unit && unit != "" ? unit.value : "",
              kioskId: !!kiosk && kiosk != "" ? kiosk.value : "",
            },
            pl: pagination.pageSize,
            pn: pagination.pageIndex + 1,
            version: "mtpx001",
          });
    var url = "management/api/v1/unitkiosks/getUnitKiosks";
    fetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == 0) {
          let newList = [];
          for (let i = 0; i < pagination.pageIndex * pagination.pageSize; i++) {
            newList.push([]);
          }
          newList = newList.concat(result.unitKiosks);
          pushData(newList);
          setUnitKiosks(newList);
          setPageCount(result.count);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((error) => setLoading(false));
  };
  const pushData = (data) => {
    const rows = [];
    const headers = [
      {
        accessorKey: "unitDescription",
        header: "حساب",
        align: "center",
      },
      {
        accessorKey: "kioskDescription",
        header: "لاکر",
        align: "center",
      },
      {
        accessorKey: "serials",
        header: "باکس های مجاز",
        align: "center",
      },
      {
        accessorKey: "isActive",
        header: "وضعیت",
        align: "center",
      },
    ];
    const buttons = [];
    setTableData({ rows: rows, headers: headers, buttons: buttons });
    data.map((d) => {
      rows.push({
        id: d.id,
        unitDescription: d.unitDescription,
        kioskDescription: d.kioskDescription,
        serials: d.serials,
        isActive: d.isActive && d.isActive == "1" ? "فعال است" : "فعال نیست",
      });
    });
    buttons.push({ id: 1, text: "ویرایش", clicked: editUnitKiosk });
    buttons.push({ id: 6, text: "تغییر وضعیت", clicked: unitKioskChangeState });
    setTableData({ rows: rows, headers: headers, buttons: buttons });
    setRerender(!rerender);
  };

  const search = () => {
    getData({ pageIndex: pageIndex, pageSize: pageSize });
  };

  const refresh = () => {
    setUnit("");
    setKiosk("");
    getData({ pageIndex: pageIndex, pageSize: pageSize }, true);
  };

  const editUnitKiosk = (id, data) => {
    const kioskUnt = data.filter((k) => k.id === id);
    if (!!kioskUnt && kioskUnt.length != 0) {
      setUnitKiosk(kioskUnt[0]);
      setEdit(true);
      setShowUnitKioskForm(true);
    }
  };

  const addNewUnitKiosk = () => {
    setUnitKiosk("");
    setEdit(false);
    setShowUnitKioskForm(true);
  };

  const copyUnitKiosk = () => {
    setModalContent(
      <CopyUnitKioskForm back={() => ref.current.closeModal()} />
    );
    ref.current.openModal();
  };

  const exportToCSV = (event) => {
    var raw = JSON.stringify({
      unitKiosk: {
        unitId: !!unit && unit != "" ? unit.value : "",
        kioskId: !!kiosk && kiosk != "" ? kiosk.value : "",
      },
      pl: "1048576",
      pn: "1",
      version: "mtpx001",
    });
    var url = "management/api/v1/unitkiosks/getUnitKiosks";
    setLoading(true);
    fetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        setLoading(false);
        if (result.status == 0) {
          let exportOrderReport = [];
          let count = 0;
          const orderReport = result.unitKiosks.map((o) => {
            count++;
            exportOrderReport.push({
              ردیف: count,
              "نام لاکر": o.kioskDescription,
              حساب: o.unitDescription,
              "باکس های مجاز": o.serials,
            });
          });
          const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
          const fileExtension = ".xlsx";
          const ws = XLSX.utils.json_to_sheet(exportOrderReport);
          const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
          const excelBuffer = XLSX.write(wb, {
            bookType: "xlsx",
            type: "array",
          });
          const data = new Blob([excelBuffer], { type: fileType });
          FileSaver.saveAs(data, "lockerUnits" + fileExtension);
        }
      })
      .catch((error) => setLoading(false));
  };

  let unitList = [];
  if (units != null && units.length != 0) {
    units.map((z) => {
      unitList.push({
        value: z.id,
        label: z.unitName,
      });
    });
  }

  let kioskList = [];
  if (kiosks != null && kiosks.length != 0) {
    kiosks.map((z) => {
      kioskList.push({
        value: z.id,
        label: z.description,
      });
    });
  }
  const afterCloseModal = (event) => {};
  let form = (
    <div>
      <div className="row pl-4" dir="ltr" style={{ height: "0px" }}>
        <Button btnType="Refresh" clicked={refresh}></Button>
      </div>
      <div className="row mt-4">
        <SelectKiosk
          name="form-field-name"
          value={unit}
          placeholder="حساب"
          options={unitList}
          onChange={changeUnit}
          col="4 mt-2"
        />
        <SelectKiosk
          name="form-field-name"
          value={kiosk}
          placeholder="لاکر"
          options={kioskList}
          onChange={changeKiosk}
          col="4 mt-2"
        />
      </div>
      <div className="row text-left" dir="ltr">
        <div className="col-2">
          <Button btnType="search-btn" clicked={search}>
            جستجو
          </Button>
        </div>
        <div className="col-2">
          <Button btnType="Search" clicked={exportToCSV}>
            <span className="tab-color">گزارشگیری</span>
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <Collapse in={!showUnitKioskForm}>
        <LocalSearch class="orders-search" form={form} />

        <div className="row justify-content-end mt-3">
          <div className="col" style={{ maxWidth: 60, width: 60 }}>
            <div onClick={copyUnitKiosk} className="Add mb-2">
              <ContentCopyIcon
                style={{
                  width: 30,
                  fontSize: 30,
                  height: 30,
                  color: "#FE110D",
                  cursor: "pointer",
                }}
              />
            </div>
          </div>
          <div className="col" style={{ maxWidth: 60, width: 60 }}>
            <div onClick={addNewUnitKiosk} className="Add mb-2">
              <Add className="UserIcon" />
            </div>
          </div>
        </div>

        {rerender ? (
          // <Spinner />
          <Table
            hasDetails={false}
            pageSize={pageSize}
            data={unitKiosks}
            pageIndex={pageIndex}
            getData={getData}
            list={tableData}
            rowCount={pageCount}
            columnSize={400}
            loading={loading}
          />
        ) : (
          <Table
            hasDetails={false}
            pageSize={pageSize}
            data={unitKiosks}
            pageIndex={pageIndex}
            getData={getData}
            list={tableData}
            rowCount={pageCount}
            columnSize={400}
            loading={loading}
          />
        )}
      </Collapse>
      <Collapse in={showUnitKioskForm}>
        <UnitKioskForm
          reload={() => {
            setShowUnitKioskForm(false);
            search();
          }}
          back={() => {
            setShowUnitKioskForm(false);
          }}
          edit={edit}
          unitKiosk={unitKiosk}
        />
      </Collapse>
      <Modal
        content={modalContent}
        ref={ref}
        closePermission="true"
        closeModal={(event) => afterCloseModal(event)}
      />
    </>
  );
};

export default UnitKiosks;
